// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4VWX4","tabsBox":"styles_tabsBox__3OwsV","createButton":"styles_createButton__22csL"};